<template>
  <van-popup v-model="show" round class="language-popup">
    <div class="main">
      <div class="title">请选择语言</div>
      <div class="title en-title">Please select a language</div>
      <div class="list">
        <div v-for="(item, index) in languageList" :key="item.value">
          <div v-if="index !== 0" class="line"></div>
          <div
            class="item"
            :class="{
              active: $store.state.language === item.value,
            }"
            @click="changeLanguage(item.value)"
          >
            {{ item.label }}
          </div>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import Vue from "vue";
import { Popup } from "vant";

Vue.use(Popup);

export default {
  name: "changeLanguagePopup",
  data() {
    return {
      show: false,
      languageList: [
        {
          label: "简体中文",
          value: "zh-Hans",
        },
        {
          label: "繁体中文",
          value: "zh-Hant",
        },
        {
          label: "English",
          value: "en",
        },
      ],
    };
  },
  methods: {
    changeLanguage(language) {
      if (
        this.$store &&
        this.$store._mutations &&
        this.$store._mutations.CHANGE_language
      ) {
        this.$store.commit("CHANGE_language", language);
      }

      if (this.$i18n) {
        this.$i18n.locale = language;
      }
      this.show = false;
    },
    open() {
      this.show = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.language-popup {
  width: 76.5333vw;
  border-radius: 2.1333vw;
  overflow: hidden;
}

.main {
  width: 100%;
  padding-top: 4vw;
  padding-bottom: 2.6667vw;
  background: #ffffff;
  text-align: center;

  .title {
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 4.2667vw;
    color: #000000;
    font-style: normal;
  }

  .en-title {
    margin-top: 1.0667vw;
  }

  .list {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 5.6vw;

    .line {
      width: 64vw;
      height: 1px;
      background: #666666;
      opacity: 0.1;
    }

    .item {
      margin: 4vw 0;
      font-family: PingFang SC, PingFang SC;
      font-weight: bold;
      font-size: 3.7333vw;
      color: #333333;
      font-style: normal;
    }

    .active {
      color: #1f10e0;
    }
  }
}
</style>
